<template>
  <div class="dialog-login" @click="dialogCancel" @touchmove="dialogCancel">
      <div class="login-content">
          <div class="login-image">
              <img src="//statics.itc.cn/WAP_base/right.png">
          </div>
          <div class="login-text-bold">点赞成功</div>
          <div class="login-text">登录参与更多精彩互动</div>
          <div class="login-href" @click.stop="loginHref">登录查看我赞过的文章</div>
          <div class="login-cancel">取消</div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
        }
    },
  methods: {
    dialogCancel() {
        window.MptcfeUtils.Utils.sendSpmAction(10218)
        this.$emit('closeDialogLogin')
    },
    loginHref() {
        const r = document.location.origin + '/ucenter/likeArticle'
        window.location.href = `https://${this.getMobileSiteHost()}/login?r=${encodeURIComponent(r)}&spm=smwp.content.first-thumb.0`
    },
    getEnvironment() {
        var _result = "prod"
        var _host = window.location.host
        if(!(/^(t3\.m|n\.m|feed\.m|m|pre\.beta\.www|www)\.sohu(\.com)?/.test(_host))) _result = "test"
        if(/^(t3\.m|pre\.beta\.www)\.sohu(\.com)?/.test(_host)) _result = "pre"
        let envMap = ['test', 'pre', 'prod']
        if(envMap.indexOf(window.deployEnv) > -1) _result = window.deployEnv
        return _result
    },
    getMobileSiteHost: function() {
        let _mobileSiteHostMap = {
            "test": "//test-m.sohu.com",
            "pre": "//pre-m.sohu.com",
            "prod": "//m.sohu.com",
        }

        return _mobileSiteHostMap[this.getEnvironment()]
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-login{
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.4);
    width: 100%;
    height: 100%;
    z-index: 1001;
    .login-content {
        position: absolute;
        width: 560px;/*px*/
        height: 538px;/*px*/
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #fff;
        box-sizing: border-box;
        padding: 48px 64px;/*px*/
        text-align: center;
        .login-image {
            display: flex;
            justify-content: center;
            img {
                width: 112px;/*px*/
                height: 112px;/*px*/
                margin-bottom: 0;
            }
        }
        .login-text-bold {
            margin-top: 32px;/*px*/
            color: #111;
            font-size: 36px;/*px*/
            font-family: PingFangSC-Medium, PingFang SC;
        }
        .login-text {
            margin-top: 16px;/*px*/
            color: #999;
            font-size: 28px;/*px*/

        }
        .login-href {
            margin-top: 48px;/*px*/
            height: 72px;/*px*/
            line-height: 72px;/*px*/
            background: #ffd100;
            font-size: 28px;/*px*/
            font-family: PingFangSC-Medium, PingFang SC;
            color: #111;
        }
        .login-cancel {
            margin-top: 16px;/*px*/
            height: 72px;/*px*/
            line-height: 72px;/*px*/
            font-size: 28px;/*px*/
            color: #111;
        }
    }
}
</style>